"use client"

import dynamic from "next/dynamic"
import { ComponentType } from "react"
import type { MarketRate } from "@/app/utils/loan-work-time"

interface TempsTravailCreditProps {
    marketRate?: MarketRate
}

// Code-split so guide pages without the tool never ship it, but server-rendered so its copy stays crawlable
const TempsTravailCredit = dynamic(
    () =>
        import("@/app/components/atomic/organisms/TempsTravailCredit") as Promise<{
            default: ComponentType<TempsTravailCreditProps>
        }>,
)

const TempsTravailCreditCompact = dynamic(
    () =>
        import("@/app/components/atomic/organisms/TempsTravailCreditCompact") as Promise<{
            default: ComponentType<TempsTravailCreditProps>
        }>,
)

const TempsTravailCreditLazy = ({ compact = false, ...props }: TempsTravailCreditProps & { compact?: boolean }) =>
    compact ? <TempsTravailCreditCompact {...props} /> : <TempsTravailCredit {...props} />

export default TempsTravailCreditLazy
